import React from 'react';
import RiskButton from './RiskButton';

function MediumRiskButton(props) {
    return (
        <RiskButton
            active={props.active}
            buttonText="Medium"
            buttonColor="var(--orange)"
        />
    );
}

export default MediumRiskButton;
